import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import { useDashboard } from "./DashboardProvider";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const ResponsiveGridLayout = WidthProvider(Responsive);

export default function DashboardGrid({
  breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  cols = { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  rowHeight = 30,
  ...rest
}) {
  const { layouts, widgets, updateLayouts } = useDashboard();

  // onLayoutChange receives (layout, allLayouts)
  return (
    <ResponsiveGridLayout
      className="layout"
      layouts={layouts}
      breakpoints={breakpoints}
      cols={cols}
      rowHeight={rowHeight}
      onLayoutChange={(layout, allLayouts) => updateLayouts(allLayouts)}
      measureBeforeMount={false}
      useCSSTransforms={true}
      draggableHandle=".widget-drag-handle"
      {...rest}
    >
      {widgets.map((w) => (
        <div key={w.id} data-grid={undefined}>
          <div className="widget">
            {/* you can style a drag handle inside the widget */}
            {w.component}
          </div>
        </div>
      ))}
    </ResponsiveGridLayout>
  );
}
